import React from "react";
import { selectChargesColumn } from "./constant";
import styles from "./styles.module.scss";
import CustomTooltip from "../../../../common/customTooltip/CustomTooltip";
const TableHeader = () => {
  return (
    <div className={`${styles["table-header"]} text-bold label-color pb-2`}>
      <div>
      </div>
      {selectChargesColumn.map((item) => (
        <CustomTooltip key={item.label} title={item.hoverDescription}>
          <div key={item.label}>{item.label}</div>
        </CustomTooltip>
      ))}
      <div></div>
      <div></div>
    </div>
  );
};

export default TableHeader;
